let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = Promise.all([load("bRMot"), load("gYyBP"), load("aCh9P"), load("bxxT5"), load("39ohJ")]).then(() => parcelRequire('1jMgA'));